import { styled } from 'stitches.config'

export const SignupRoot = styled('div', {
  backgroundColor: '$accent-white',
  color: '$accent-black',
  py: '$6',
  px: '$3',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$8',

  '@bp2': {
    px: '$15',
    flexDirection: 'row',
  },
})

export const ImageContainer = styled('figure', {
  width: '367px',
  flexShrink: '0',
})

export const Content = styled('div', {
  maxWidth: '578px',
})
